import {Component, DoCheck, inject, IterableDiffers} from "@angular/core";
import {ToasterNotificationModel} from "./models";
import {toasterNotificationConfig} from "./configs";
import {animate, style, transition, trigger} from "@angular/animations";
import {ToasterRef} from "./refs";
import {Observable} from "rxjs";
import {ToasterNotificationComponent} from "./components/toaster-notification.component";

@Component({
	standalone: true,
	selector: "er-toaster",
	templateUrl: "toaster.component.html",
	styleUrls: ["toaster.component.scss"],
	animations: [
		trigger('fade', [
			transition(':enter', [style({ opacity: 0 }), animate('500ms ease-in-out', style({ opacity: 1 }))]),
			transition(':leave', [style({ opacity: 1 }), animate('500ms ease-in-out', style({ opacity: 0, height: 0, margin: 0 }))]),
		])
	],
	imports: [ToasterNotificationComponent]
})
export class ToasterComponent implements DoCheck {

	public toasterNotifications: ToasterNotificationModel[] = [];

	private iterableDiffers: IterableDiffers = inject(IterableDiffers);
	private iterableDiffer: any = this.iterableDiffers.find([]).create();

	constructor(private pushNotification$: Observable<ToasterNotificationModel>,
	            private readonly toasterRef: ToasterRef) {
		this.pushNotification$.subscribe((toasterNotification: ToasterNotificationModel): void => {
			this.pushNotification(toasterNotification)
		});
	}

	public ngDoCheck(): void {
		const toasterNotificationsChanges: any = this.iterableDiffer.diff(this.toasterNotifications);
		if (toasterNotificationsChanges && !(toasterNotificationsChanges.length > 0)) {
			this.detachToaster();
		}
	}

	public closeNotification(toasterNotification: ToasterNotificationModel): void {
		this.toasterNotifications = this.toasterNotifications.filter(tn =>
				tn.id !== toasterNotification.id);
	}

	private pushNotification(toasterNotification: ToasterNotificationModel): void {
		if (this.toasterNotifications.length >= toasterNotificationConfig.displayLimit) {
			this.toasterNotifications.splice(0, 1);
		}
		this.toasterNotifications.push(toasterNotification);
	}

	private detachToaster(): void {
		this.toasterRef.detach();
	}
}